// extracted by mini-css-extract-plugin
export default {"dash__loader":"required-auth_dash__loader__rnJQC","dash__loadertext":"required-auth_dash__loadertext__JkxfN","dash__loader_spinner":"required-auth_dash__loader_spinner__Quxfy"};